import { gql } from '@apollo/client';
import {
  ASSESSMENT_DOMAINS_AND_SECTIONS,
  ASSESSMENT_IMPLEMENTATIONS,
} from 'graph/fragments/assessment';

const FIND_ONE_STUDENT_ASSESSMENTS = gql`
  ${ASSESSMENT_IMPLEMENTATIONS}
  ${ASSESSMENT_DOMAINS_AND_SECTIONS}

  query StudentAssessment($where: StudentAssessmentWhereInput!) {
    studentAssessment(where: $where) {
      id
      assessmentId
      studentId
      dateAdministered
      dateCompleted
      comments
      student {
        firstName
        lastName
      }
      assessment {
        id
        ...AssessmentImplementations
        ...AssessmentDomainsAndSections
      }
      outcomes {
        id
        studentId
        studentAssessmentId
        assessmentSectionId
        assessmentQuestionId
        answerTypeId
        answerTypeOptionId
      }
    }
  }
`;

export default FIND_ONE_STUDENT_ASSESSMENTS;
